import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBanner } from './components/TrustBanner';
import { Features } from './components/Features';
import { UseCases } from './components/UseCases';
import { TechStack } from './components/TechStack';
import { Testimonials } from './components/Testimonials';
import { Security } from './components/Security';
import { Pricing } from './components/Pricing';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Refunds } from './pages/Refunds';
import { Shipping } from './pages/Shipping';
import { Contact } from './pages/Contact';

const HomePage = () => (
  <>
    <Hero />
    <TrustBanner />
    <Features />
    <UseCases />
    <TechStack />
    <Security />
    <Testimonials />
    <Pricing />
    <CTA />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refunds" element={<Refunds />} />
          <Route path="/shipping" element={<Shipping />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;